import { useEffect } from 'react';

export default function Toast({ message, type = 'success', onClose }) {
  useEffect(() => {
    if (!message) return;

    // Auto-dismiss the toast after 3 seconds
    const timer = setTimeout(() => {
      onClose();
    }, 3000);

    return () => clearTimeout(timer);
  }, [message, onClose]);

  if (!message) return null;

  // Set colors based on success or error type
  const isSuccess = type === 'success';
  const bgColor = isSuccess ? 'bg-green-600' : 'bg-red-500';
  const icon = isSuccess ? '✓' : '✕';

  return (
    <div className="fixed bottom-6 right-6 z-50 animate-fade-in-up">
      <div className={`${bgColor} text-white px-5 py-3 rounded-lg shadow-xl flex items-center gap-3 min-w-[250px]`}>
        <span className="font-bold text-lg">{icon}</span>
        <p className="text-sm font-medium">{message}</p>
        <button 
          onClick={onClose}
          className="ml-auto text-white/80 hover:text-white font-bold"
        >
          &times;
        </button>
      </div>
    </div>
  );
}